<script setup>
import { onMounted, ref } from 'vue'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings.js'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()

import Calendar from './Calendar.vue'
import DateLoader from './DateLoader.vue'
import Main from '../layout/Main.vue'

onMounted(async () => {
    // $appointments.matchAppointmentPreRequirement()
    await $appointments.fetchAvailableDates(null, null, 60)
})

const updateAppointment = (value) => {
    $appointments.setAppointment('booking_date', value)
    $appointments.fetchAvailableSlots()
}
</script>

<style lang="scss" scoped></style>

<template>
    <Main>
        <template #content>
            <div class="date-page-title" :style="$customizer.titleStyle">{{ $settings.customizer.date.title || '' }}</div>

            <!-- empty date loader -->
            <DateLoader v-if="!$appointments.isAvailableDatesLoaded" />

            <!-- date calendar -->
            <Calendar v-if="$appointments.isAvailableDatesLoaded" v-model="$appointments.appointment.booking_date" @change="(value) => updateAppointment(value)" />

        </template>
    </Main>
</template>